export const FETCH_SURVEYS_REQUEST = "FETCH_SURVEYS_REQUEST";
export const FETCH_SURVEYS_SUCCESS = "FETCH_SURVEYS_SUCCESS";
export const FETCH_SURVEYS_FAIL = "FETCH_SURVEYS_FAIL";
export const FETCH_SURVEY_REQUEST = "FETCH_SURVEY_REQUEST";
export const FETCH_SURVEY_SUCCESS = "FETCH_SURVEY_SUCCESS";
export const FETCH_SURVEY_FAIL = "FETCH_SURVEY_FAIL";
export const DOWNLOAD_SURVEYS_REQUEST = "DOWNLOAD_SURVEYS_REQUEST";
export const DOWNLOAD_SURVEYS_SUCCESS = "DOWNLOAD_SURVEYS_SUCCESS";
export const DOWNLOAD_SURVEYS_FAIL = "DOWNLOAD_SURVEYS_FAIL";
export const RESET_DOWNLOAD_CSV = "RESET_DOWNLOAD_CSV";
